import { render, staticRenderFns } from "./lastOrder.vue?vue&type=template&id=3fb9ce45&scoped=true"
import script from "./lastOrder.vue?vue&type=script&lang=js"
export * from "./lastOrder.vue?vue&type=script&lang=js"
import style0 from "./lastOrder.vue?vue&type=style&index=0&id=3fb9ce45&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9ce45",
  null
  
)

export default component.exports